<template>
  <div style="width: 100%;">
    <div
      v-if="!hide"
      v-tippy="tippyOptions"
      :content="content"
      class="tooltip_label"
      :style="fullWidth ? 'width: 100%' : ''"
    >
      <slot name="body" />
    </div>
    <div
      v-if="hide"
      :content="content"
      class="tooltip_label"
      :style="fullWidth ? 'width: 100%' : ''"
    >
      <slot name="body" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tooltip',
  props: {
    content: {
      type: String,
      required: true,
    },
    position: {
      type: String,
      required: false,
      default: 'top',
    },
    interactive: {
      type: Boolean,
      required: false,
      default: false,
    },
    hide: {
      type: Boolean,
      required: false,
      default: false,
    },
    withAnimation: {
      type: Boolean,
      required: false,
      default: true,
    },
    fullWidth: {
      type: Boolean,
      required: false,
      default: false,
    },
    delay: {
      type: [Number, Array],
      required: false,
      default: 0,
    },
    triggerTarget: {
      type: Object,
      required: false,
      default: null,
    },
    maxWidth: { type: Number, required: false, default: 250 },
    fallbackPlacements: {
      type: Array,
      default: () => ['top', 'bottom', 'left', 'right', 'bottom-end'],
    },
  },
  computed: {
    tippyOptions() {
      let options = {
        content: this.content,
        placement: this.position,
        interactive: this.interactive,
        duration: [this.withAnimation ? 275 : 0, 0],
        delay: this.delay,
        a11y: false,
        flip: true,
        popperOptions: {
          modifiers: [
            {
              name: 'flip',
              options: {
                fallbackPlacements: this.fallbackPlacements,
              },
            },
          ],
        },
      };

      if (!this.fullWidth) {
        options = {
          ...options,
          maxWidth: this.maxWidth,
        };
      }

      return options;
    },
  },
};
</script>

<style lang='less' src="./less/tooltip.less"></style>
